<template>
    <div class="defa-file-upload-main-aedecp">
        <div ref="dropArea" class="defa-Fupload-drag-area-aedecp drag-area" @change="change" @dragover="dragover"
            @dragleave="dragleave" @drop="drop">
            <div class="defa-Fupload-drag-icon-aedecp"><i class="fa-regular fa-file-upload"></i></div>
            <h3>Glisser et déposer vos fichiers ici</h3>
            <p>Fichiers supportés : PDF, Jpeg, PNG, BMP</p>
            <button ref="button" class="btn default-btnH40-aehp">Parcourir</button>
            <input ref="input" type="file" hidden>
            <div class="defa-Fupload-drag-note-aedecp"> La taille du fichier ne doit pas dépasser 10 Mo</div>
        </div>
        <div v-if="error" class="error-message">{{ error }}</div>
        <div class="render row">
            <div v-for="(item, key) in images" :key="key" class="picture col-md-6 col-12">
                <div class="defa-Fupload-list-main-aedecp">
                    <div class="defa-upload-file-box1-aedecp">
                        <div class="defa-ULfile-box-icon-aedecp"><i class="fa-regular fa-file-image"></i></div>
                        <div class="defa-ULfile-box-info-aedecp">
                            <div class="defa-ULfile-box-close-aedecp" v-on:click="deleteImage(key)"><a href="#"><i
                                        class="fa-regular fa-circle-xmark"></i></a></div>
                            <div class="defa-ULfile-name-aedecp">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DragAndDrop',
    props: {
        max: {
            type: Number,
        }
    },
    data() {
        return {
            images: [],
            error: null,
        };
    },
    mounted() {
        this.$refs.button.onclick = () => {
            this.$refs.input.click(); //if user click on the button then the input also clicked
        }
    },
    methods: {
        validateFileSize(file) {
            this.error = null; // Reset error message before validation
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
            if (file.size > maxSize) {
                this.error = "La taille du fichier dépasse 10 Mo";
                return false;
            }
            return true;
        },
        checkMaxFiles() {
            if (this.max && this.images.length >= this.max) {
                this.error = `Vous ne pouvez pas télécharger plus de ${this.max} fichier(s)`;
                return false;
            }
            return true;
        },
        change() {
            let file = this.$refs.input.files[0];
            if (!this.checkMaxFiles() || !this.validateFileSize(file)) return;

            this.$refs.dropArea.classList.add("active");
            const that = this;

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                that.images.push({ name: file.name, state: '0', buffer: reader.result, type: file.type.split('/')[1] });
                that.$emit('updateImages', { images: that.images });
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },
        dragover(event) {
            event.preventDefault(); //preventing from default behaviour
            this.$refs.dropArea.classList.add("active");
        },
        dragleave() {
            this.$refs.dropArea.classList.remove("active");
        },
        drop(event) {
            event.preventDefault(); //preventing from default behaviour
            const file = event.dataTransfer.files[0];
            if (!this.checkMaxFiles() || !this.validateFileSize(file)) return;

            const that = this;

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                that.images.push({ name: file.name, state: '0', buffer: reader.result, type: file.type.split('/')[1] });
                that.$emit('updateImages', { images: that.images });
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },
        deleteImage(index) {
            this.images.splice(index, 1);
            this.$emit('updateImages', { images: this.images });
        }
    }
}
</script>

<style scoped>
.error-message {
    color: #ff0000;
    margin-top: 10px;
    font-size: 14px;
    text-align: left;
    width: 100%;
}
</style>
